export default function ScreenWarning() {
  return (
    <div className="screen-warning">
      <p>This portfolio looks best on a larger screen.</p>
      <p>Please switch to a desktop or tablet for the full experience.</p>
    </div>
  );
}